var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "portal",
    {
      ref: "portal",
      attrs: {
        to: "toast",
        disabled: !_vm.siteLevel,
        slim: _vm.slim ? true : undefined
      }
    },
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.currentVisible
          ? _c("li", { staticClass: "toasts__item" }, [
              _c(
                "div",
                {
                  class: ["toast", ..._vm.stateClassList],
                  attrs: { "data-testid": "toast" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "toast__indicator-icon",
                      attrs: { "data-testid": "toast-icon" }
                    },
                    [_c("i", { staticClass: "icon", class: _vm.iconClassName })]
                  ),
                  _c("div", { staticClass: "toast__content-region" }, [
                    _vm.showHeader
                      ? _c(
                          "header",
                          {
                            staticClass: "toast__header",
                            attrs: { "data-testid": "toast-header" }
                          },
                          [
                            _vm.title
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "toast__header-title",
                                    attrs: { "data-testid": "title" }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.title) + " ")]
                                )
                              : _vm._e(),
                            _vm.subtitle
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "toast__header-subtitle",
                                    attrs: { "data-testid": "subtitle" }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "toast__body",
                        attrs: { "data-testid": "bodyMsg" }
                      },
                      [
                        _vm.$slots.bodyMsg
                          ? _c(
                              "div",
                              { staticClass: "toast__body-msg" },
                              [_vm._t("bodyMsg")],
                              2
                            )
                          : _vm._e(),
                        _vm.$slots.bodyAction
                          ? _c(
                              "div",
                              {
                                staticClass: "toast__body-action",
                                attrs: { "data-testid": "bodyAction" }
                              },
                              [_vm._t("bodyAction")],
                              2
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm.$slots.footerAction
                      ? _c(
                          "footer",
                          {
                            staticClass: "toast__footer-action",
                            attrs: { "data-testid": "footerAction" }
                          },
                          [_vm._t("footerAction")],
                          2
                        )
                      : _vm._e()
                  ]),
                  _c("ButtonIcon", {
                    staticClass: "toast__close-btn",
                    attrs: {
                      iconClassName: "icon-remove",
                      variant: "topRight",
                      "data-testid": "toast-close-btn"
                    },
                    on: { click: _vm.onClickClose }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }